module.exports = __webpack_public_path__ + "static/media/understand.bb8f616f.mp3";